export default __webpack_public_path__ + "static/media/MoveClean.075b1858.jpg";